import { Component } from '@angular/core'

import { environment } from './../environments/environment'
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styles: [],
})
export class AppComponent {
  public title = 'Vanguard Investment Products List'
  public environment = environment
}
